import React from 'react'
import { Navbar, Nav, Container, Button, Form } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import '../../modern-theme.css'
import Dropdown from 'react-bootstrap/Dropdown'

function Headerbar() {
  const rolename = capitalizeFirstLetter(localStorage.getItem('role'))
  const first_name = localStorage.getItem('first_name')
  const last_name = localStorage.getItem('last_name')
  const navigate = useNavigate()
  const [cookies, setCookie, removeCookie] = useCookies([])

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    localStorage.removeItem('first_name')
    localStorage.removeItem('last_name')
    localStorage.removeItem('userid')
    navigate('/')
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  return (
    <>
      <div className="horizontal-menu">
        <nav className="navbar top-navbar col-lg-12 col-12 p-0">
          <div className="container">
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
              <a className="navbar-brand brand-logo" href="/">
                <img src="/images/logo-text.png" alt="logo" />
              </a>
              <a className="navbar-brand brand-logo-mini" href="/">
                <img src="/images/logo-text.png" alt="logo" />
              </a>
            </div>
            <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
              <ul className="navbar-nav navbar-nav-right">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link"
                    id="languageDropdown"
                    href="/tests"
                    data-toggle="dropdown"
                  >
                    ACT <i className="mdi mdi-chevron-down mdi-24px"></i>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                    aria-labelledby="languageDropdown"
                  >
                    <a href="/add_test" className="dropdown-item preview-item">
                      New Exam
                    </a>
                    <a href="/tests" className="dropdown-item preview-item">
                      All Exams
                    </a>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link font-weight-medium"
                    id="languageDropdown"
                    href="/sattests"
                    data-toggle="dropdown"
                  >
                    SAT <i className="mdi mdi-chevron-down mdi-24px"></i>
                  </a>
                  <div
                    className="dropdown-menu dropdown-menu-right navbar-dropdown preview-list"
                    aria-labelledby="languageDropdown"
                  >
                    <a href="/topics" className="dropdown-item preview-item">
                      Topic
                    </a>
                    <a href="/subtopics" className="dropdown-item preview-item">
                      Sub Topic
                    </a>
                    <a
                      href="/add_sattest"
                      className="dropdown-item preview-item"
                    >
                      New Exam
                    </a>
                    <a href="/sattests" className="dropdown-item preview-item">
                      All Exams
                    </a>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a
                    style={{ cursor: 'pointer' }}
                    className="nav-link font-weight-medium"
                    id="languageDropdown"
                    onClick={handleLogout}
                  >
                    LOGOUT <i className="mdi mdi-chevron-down mdi-24px"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="link"
                      id="profileDropdown-navbar"
                      className="nav-link"
                      style={{ boxShadow: 'none', border: 'none', padding: 0 }}
                    >
                      <img
                        src="https://demo.bootstrapdash.com/dashflat/template/images/faces/face28.png"
                        alt="profile"
                      />
                      <i className="mdi mdi-chevron-down mdi-24px"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="navbar-dropdown preview-list">
                      <Dropdown.Item href="/subtopics" className="preview-item">
                        <span className="profile-name font-weight-bold">
                          Logged in as {first_name} {last_name}
                          <br />
                          (Role as a {rolename})
                        </span>
                      </Dropdown.Item>
                      <Dropdown.Item href="/subtopics" className="preview-item">
                        My Profile
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={handleLogout}
                        className="preview-item"
                      >
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <nav className="bottom-navbar">
          <div className="container">
            <ul className="nav page-navigation">
              <li className="nav-item">
                <a className="nav-link" href="/dashboard">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/home.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Dashboard</span>
                </a>
              </li>
              {rolename === 'Admin' && (
                <li className="nav-item mega-menu">
                  <a href="/admins" className="nav-link">
                    <img
                      src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/ui.svg"
                      alt=""
                      className="nav-icon-title"
                    />
                    <span className="menu-title">Sub Admins</span>
                  </a>
                </li>
              )}
              <li className="nav-item">
                <a className="nav-link" href="/parents">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/widget.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Parents</span>
                </a>
              </li>
              <li className="nav-item mega-menu">
                <a href="/students" className="nav-link">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/ui.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Students</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/batches" className="nav-link">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/form.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Batches</span>
                </a>
              </li>
              <li className="nav-item mega-menu">
                <a href="#" className="nav-link">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/data.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Transactions</span>
                </a>
              </li>
              <li className="nav-item mega-menu">
                <a href="#" className="nav-link">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/pages.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Reports</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="#" className="nav-link">
                  <img
                    src="https://demo.bootstrapdash.com/dashflat/template/images/sidebar/web.svg"
                    alt=""
                    className="nav-icon-title"
                  />
                  <span className="menu-title">Audit</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  )
}

export default Headerbar
